/* ═══════════════════════════════════════════════════════════
   SPAN Product Page Behavior
   ─────────────────────────────────────────────────────────
   Where this goes: same Assets folder as the CSS file.
   Add a new asset → blank file → name it exactly
   "main-product-span.js" → paste this entire file.
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.span-product');
  if (!root) return;

  /* ───────── Gallery thumbnail swap ───────── */
  var mainImage = document.getElementById('SpanMainImage');
  var thumbs = root.querySelectorAll('.span-product__thumb');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImage) {
        mainImage.style.opacity = '0';
        setTimeout(function () {
          mainImage.src = thumb.dataset.full;
          mainImage.alt = thumb.dataset.alt || mainImage.alt;
          mainImage.style.opacity = '1';
        }, 120);
      }
    });
  });

  /* ───────── Quantity stepper ───────── */
  var qtyInput = document.getElementById('SpanQtyInput');
  var qtyMinus = document.getElementById('SpanQtyMinus');
  var qtyPlus = document.getElementById('SpanQtyPlus');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  /* ───────── Accordion ───────── */
  var heads = root.querySelectorAll('.span-accordion__head');
  heads.forEach(function (head) {
    head.addEventListener('click', function () {
      var body = head.nextElementSibling;
      var isOpen = body.classList.contains('is-open');

      // close all others for a clean single-open accordion
      root.querySelectorAll('.span-accordion__body').forEach(function (b) {
        b.classList.remove('is-open');
      });
      root.querySelectorAll('.span-accordion__head').forEach(function (h) {
        h.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        body.classList.add('is-open');
        head.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ───────── Variant price update ───────── */
  // Keeps the displayed price in sync if the customer switches variants.
  var variantSelect = document.getElementById('SpanVariantSelect');
  var priceEl = document.getElementById('SpanPrice');

  if (variantSelect && priceEl && window.SpanVariantPrices) {
    variantSelect.addEventListener('change', function () {
      var price = window.SpanVariantPrices[this.value];
      if (price) priceEl.textContent = price;
    });
  }
});
